import React from 'react';

import { CmBox, CmFlex, CmStack, CmText } from '@/components/uiParts';
import { ChevronRightIcon } from '@/components/uiParts';
import { CustomGroup } from '@/pages/link-items/LinkItemsPage';

import { LinkedItem } from '.';

type Props = {
  group: CustomGroup;
  handleDeleteGroupItem: (groupIndex: number, itemIndex: number) => void;
  handleToggleGroupAccordion: (groupIndex: number) => void;
  groupIndex: number;
};

export const AccordionLinkedItemsArea: React.FC<Props> = ({
  group,
  handleDeleteGroupItem,
  handleToggleGroupAccordion,
  groupIndex,
}) => {
  const isExpanded = group.isExpanded;

  const onClick = (e: React.MouseEvent<HTMLParagraphElement>) => {
    e.stopPropagation();
    handleToggleGroupAccordion(groupIndex);
  };
  return (
    <CmFlex>
      <CmBox h="100%" marginTop="15px" marginRight="5px" {...{ onClick }}>
        <ChevronRightIcon
          fontSize="30px"
          transform={isExpanded ? 'rotate(90deg)' : 'none'}
        />
      </CmBox>

      <CmStack w="100%" spacing="2">
        {isExpanded ? (
          group.linked_store_items.map((item, itemIndex) => (
            <LinkedItem
              key={itemIndex}
              {...{
                handleDeleteGroupItem,
                item,
                groupIndex,
                itemIndex,
              }}
            />
          ))
        ) : (
          <CmText lineHeight="30px" marginTop="15px" {...{ onClick }}>
            計 {group.linked_store_items.length} 点の商品
          </CmText>
        )}
      </CmStack>
    </CmFlex>
  );
};
